const S36_CotyledonScatter=[
    {
        "group": "S36C",
        "sample": "DAP12_1",
        "sample_group": "DAP12",
        "PC1": -26.1729389949922,
        "PC2": 20.3313103726825
    },
    {
        "group": "S36C",
        "sample": "DAP12_2",
        "sample_group": "DAP12",
        "PC1": -22.9869986102987,
        "PC2": 23.1911640736659
    },
    {
        "group": "S36C",
        "sample": "DAP12_3",
        "sample_group": "DAP12",
        "PC1": -20.7899483335778,
        "PC2": 28.8829714097527
    },
    {
        "group": "S36C",
        "sample": "DAP15_1",
        "sample_group": "DAP15",
        "PC1": 4.49812063863716,
        "PC2": 31.9807632616876
    },
    {
        "group": "S36C",
        "sample": "DAP15_2",
        "sample_group": "DAP15",
        "PC1": -0.17392302462754,
        "PC2": 29.4386776605127
    },
    {
        "group": "S36C",
        "sample": "DAP15_3",
        "sample_group": "DAP15",
        "PC1": -1.90688576117645,
        "PC2": 36.710587769698
    },
    {
        "group": "S36C",
        "sample": "DAP18_1",
        "sample_group": "DAP18",
        "PC1": 32.3061349302384,
        "PC2": 9.69122667149047
    },
    {
        "group": "S36C",
        "sample": "DAP18_2",
        "sample_group": "DAP18",
        "PC1": 33.8039027720266,
        "PC2": 3.14889133203893
    },
    {
        "group": "S36C",
        "sample": "DAP18_3",
        "sample_group": "DAP18",
        "PC1": 32.9467495520034,
        "PC2": 6.11858821787546
    },
    {
        "group": "S36C",
        "sample": "DAP21_1",
        "sample_group": "DAP21",
        "PC1": 42.0458690771502,
        "PC2": -11.5518279461545
    },
    {
        "group": "S36C",
        "sample": "DAP21_2",
        "sample_group": "DAP21",
        "PC1": 41.9633417728753,
        "PC2": -11.1017029144016
    },
    {
        "group": "S36C",
        "sample": "DAP21_3",
        "sample_group": "DAP21",
        "PC1": 31.8524414737274,
        "PC2": -2.81256300525683
    },
    {
        "group": "S36C",
        "sample": "DAP24_1",
        "sample_group": "DAP24",
        "PC1": 41.685573007341,
        "PC2": -21.2415508649998
    },
    {
        "group": "S36C",
        "sample": "DAP24_2",
        "sample_group": "DAP24",
        "PC1": 41.6974477301134,
        "PC2": -20.9097034758976
    },
    {
        "group": "S36C",
        "sample": "DAP24_3",
        "sample_group": "DAP24",
        "PC1": 40.6898506780289,
        "PC2": -21.5160247534602
    },
    {
        "group": "S36C",
        "sample": "DAP6_1",
        "sample_group": "DAP6",
        "PC1": -48.1786638668756,
        "PC2": -26.2836608654539
    },
    {
        "group": "S36C",
        "sample": "DAP6_2",
        "sample_group": "DAP6",
        "PC1": -48.7291927934725,
        "PC2": -25.8094699617828
    },
    {
        "group": "S36C",
        "sample": "DAP6_3",
        "sample_group": "DAP6",
        "PC1": -45.5705212280031,
        "PC2": -19.9602131310286
    },
    {
        "group": "S36C",
        "sample": "DAP9_1",
        "sample_group": "DAP9",
        "PC1": -43.4774119608126,
        "PC2": -9.81568818656009
    },
    {
        "group": "S36C",
        "sample": "DAP9_2",
        "sample_group": "DAP9",
        "PC1": -43.6981144545927,
        "PC2": -8.68947586163548
    },
    {
        "group": "S36C",
        "sample": "DAP9_3",
        "sample_group": "DAP9",
        "PC1": -41.8048326037124,
        "PC2": -9.80229980277294
    }
]
const groupedDataS36cot = S36_CotyledonScatter.reduce((acc, curr) => {
    // 如果 group 不存在，初始化为一个空数组
    if (!acc[curr.sample_group]) {
        acc[curr.sample_group] = [];
    }
    // 将当前的对象添加到对应 sample_group 的数组中
    acc[curr.sample_group].push(curr);
    return acc;
}, {});
export default groupedDataS36cot